import app from '@/app';
import templateUrl from './watch.html';

app.component('wfWatch', {
	templateUrl,
	bindings: {
		on: '<'
	}
});
